import { render, staticRenderFns } from "./WithdrawalrecordDetail.vue?vue&type=template&id=82fb0df2&scoped=true&"
import script from "./WithdrawalrecordDetail.vue?vue&type=script&lang=js&"
export * from "./WithdrawalrecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalrecordDetail.vue?vue&type=style&index=0&id=82fb0df2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82fb0df2",
  null
  
)

export default component.exports